import { consoleEvents } from '@pb/utils'

import { PaymentMethod } from 'features/checkout/constants'
import {
  postProceedFail,
  postProceedReset,
  postProceedStart,
  setHasCompletePurchaseClicked,
} from 'features/checkout/duck/actions'
import {
  handleProceedError,
  handleProceedResponse,
  prepareProceedBody,
} from 'features/checkout/duck/operations'
import { BREAK_SIGNAL } from 'features/checkout/duck/operations/postProceed/constants'
import checkoutSelectors from 'features/checkout/duck/selectors'
import { postProceedCheckout } from 'features/checkout/requests'
import { ThunkResult } from 'redux/types'

export interface AuthError extends Error {
  code?: string
}

export interface OperationProceedOptions {
  joinClubParams?: {
    dateOfBirth: string
  }
}

export const operationProceedCheckout =
  (proceedOptions: OperationProceedOptions): ThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    dispatch(postProceedStart())
    dispatch(setHasCompletePurchaseClicked(true))
    const state = getState()
    const { code: selectedPaymentMethod } = checkoutSelectors.getSelectedPaymentMethodDetails(state)
    const isPurchaseCoveredByGiftCards = checkoutSelectors.getIsPurchaseCoveredByGiftCards(state)
    try {
      const body = await prepareProceedBody({
        state,
        dispatch,
        selectedPaymentMethod: selectedPaymentMethod as PaymentMethod,
        proceedOptions,
        isPurchaseCoveredByGiftCards,
      })

      if (body === BREAK_SIGNAL) {
        dispatch(postProceedReset())
        return
      }

      const response = await postProceedCheckout(body)

      handleProceedResponse({
        response,
        selectedPaymentMethod: selectedPaymentMethod as PaymentMethod,
        dispatch,
      })
    } catch (error) {
      consoleEvents.error('Failed to proceed purchase', error)
      dispatch(postProceedFail())
      dispatch(handleProceedError(error))
    }
  }
